import { makeEntityScaffold } from '@classpass/saga-tools';
import { DALNotFoundError } from '@classpass/dal';

export const friendbuy = makeEntityScaffold(
  'SAGA.API.FRIENDBUY',
  (client, referralCode, options = {}) =>
    client.friendbuy.getReferral(referralCode, options).catch(err => {
      // 404s just mean that code is invalid
      if (err instanceof DALNotFoundError) {
        return false;
      }
      throw err;
    }),
  { defaultKey: 1 }
);
